/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/PaymentProviders/Accounts/Content/ProviderAccount/AccountId/InfoPopover/Token/Content"
  
}) {
let constantData = 'Attached token:'
let providerAccountDescriptionTokenValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'description.token',
})
let aggregateData = fromAggregate.join(constantData, providerAccountDescriptionTokenValueData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'Attached token:'"
 data="provider_account.description.token"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}